export const GET_PROMPT_CATEGORY_SUCCESS = 'GET_PROMPT_CATEGORY_SUCCESS'
export const GET_PROMPT_CATEGORY_FAILED = 'GET_PROMPT_CATEGORY_FAILED'
export const GET_PROMPT_SUBCATEGORY_SUCCESS = 'GET_PROMPT_SUBCATEGORY_SUCCESS'
export const GET_PROMPT_SUBCATEGORY_FAILED = 'GET_PROMPT_SUBCATEGORY_FAILED'
export const GET_PROMPT_SUCCESS = 'GET_PROMPT_SUCCESS'
export const GET_PROMPT_FAILED = 'GET_PROMPT_FAILED'
export const GET_SINGLE_PROMPT_SUCCESS = 'GET_SINGLE_PROMPT_SUCCESS'
export const GET_IMAGE_GENERATION_PROMPTS_LOADING = 'GET_IMAGE_GENERATION_PROMPTS_LOADING'
export const GET_IMAGE_GENERATION_PROMPTS_SUCCESS = 'GET_IMAGE_GENERATION_PROMPTS_SUCCESS'
export const GET_IMAGE_GENERATION_PROMPTS_FAILURE = 'GET_IMAGE_GENERATION_PROMPTS_FAILURE'
export const GET_CAPITOL_DATA_SUCCESS = 'GET_CAPITOL_DATA_SUCCESS'
export const GET_CAPITOL_DATA_FAILURE = 'GET_CAPITOL_DATA_FAILURE'
export const GET_CAPITOL_CHARACTER_SUCCESS = 'GET_CAPITOL_CHARACTER_SUCCESS'
export const GET_CAPITOL_CHARACTER_FAILURE = 'GET_CAPITOL_CHARACTER_FAILURE'
